// store/keycloak.js
const hostname = window.location.hostname;

// Variables por defecto (localhost o pgjhidalgo)
let keycloakBaseUrl = process.env.VUE_APP_KEYCLOAK_URL_BASE;
let realm = process.env.VUE_APP_KEYCLOAK_REALM;
let clientId = process.env.VUE_APP_KEYCLOAK_CLIENTID;
//let clientSecret = process.env.VUE_APP_KEYCLOAK_CLIENT_SECRET;

// Si estamos en tramites.gruposorah.com, usamos las variables TEST
if (hostname === 'tramites.gruposorah.com') {
    keycloakBaseUrl = process.env.VUE_APP_KEYCLOAK_URL_BASE; // Si la base URL cambia, cámbiala aquí directo
    realm = process.env.VUE_APP_KEYCLOAK_REALM_TEST;
    clientId = process.env.VUE_APP_KEYCLOAK_CLIENTID_TEST;

}

// URI de redirección codificada
const redirectUri = encodeURIComponent(`${window.location.origin}/callback`);

export function loginRedirect() {
    const url = `${keycloakBaseUrl}/realms/${realm}/protocol/openid-connect/auth?` +
        `client_id=${clientId}&response_type=code&scope=openid&redirect_uri=${redirectUri}`;
    window.location.href = url;
}